'use client';
import Image from 'next/image';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';

interface IllustrationWrapperProps {
  small?: boolean;
}

export const IllustrationWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'small',
})<IllustrationWrapperProps>`
  display: flex;
  align-self: center;
  position: relative;
  width: 16.25rem;
  height: 16.25rem;

  ${breakpoints.desktopOrBigger} {
    width: ${props => props.small ? '16.25rem' : '22.5rem'};
    height: ${props => props.small ? '16.25rem' : '22.5rem'};
    flex-grow: 0;
  }
`;

export const Illustration = styled(Image)`
  object-fit: contain;
  height: 100%;
  width: 100%;
`;
